import React, { useEffect, useState } from "react";
import parse, { domToReact }  from "html-react-parser";

const svgCache = new Map();

function parseStyleString(styleString)
{
    return styleString.split(";").reduce((acc, declaration) =>
    {
        const [property, value] = declaration.split(":");
        if (!property || !value) return acc;
        const jsProperty = property.trim().replace(/-([a-z])/g, (_, letter) => letter.toUpperCase()); // kebab-case -> camelCase
        acc[jsProperty] = value.trim();
        return acc;
    }, {});
}

export default function DynamicSvg({src, className, ...rest})
{
    const [svgContent, setSvgContent] = useState(null);

    useEffect(() =>
    {
        if(svgCache.has(src))
        {
            setSvgContent(svgCache.get(src));
            return;
        }

        fetch(src)
            .then((res) => res.text())
            .then((text) =>
            {
                svgCache.set(src, text);
                setSvgContent(text);
            })
            .catch((err) => console.error("Failed to load SVG:", err));
    }, [src]);

    return !svgContent ? null : parse(svgContent,
    {
        replace: (domNode) =>
        {
            if (domNode.name === "svg")
            {
                const { style, class: existingClass, ...attribs } = domNode.attribs;

                const reactStyle = style ? parseStyleString(style) : undefined;

                return (
                    <svg {...attribs} {...rest} className={`${existingClass || ""} ${className || ""}`.trim()} style={reactStyle}>
                        {domToReact(domNode.children, {
                            replace: (childNode) => {
                                if (childNode.attribs?.style) {
                                    const { style: childStyle, ...childAttribs } = childNode.attribs;
                                    return React.createElement(
                                        childNode.name,
                                        {
                                            ...childAttribs,
                                            style: parseStyleString(childStyle),
                                        },
                                        domToReact(childNode.children)
                                    );
                                }
                            },
                        })}
                    </svg>
                );
            }
        },
    });
}